<div class="pagecontent">
    <div class="headercontent">
        <h1 class="header1">Trip Summary</h1>
    </div>
    <div class="ng " formGroupName="tripRequest">
        @for (date of appointmentDatesFr.controls; track date; let i = $index) {
            <div formArrayName="tripAppointments">   
                <div [formGroupName]="i" >
                    <div class="trip-appointment-date-container">
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                   {{date.get('appointmentDate')?.value | date: 'MM/dd/yyyy' }} 
                                    at {{ date.get('appointmentTime')?.value | date: 'shortTime'}}
                                </mat-panel-title>
                                <mat-panel-description>
                                    View legs breakdown
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="legs-container">
                                @for (leg of getAppointmentLegs(i).controls; track leg; let j = $index) {
                                    <div formArrayName="tripLegs">  
                                        <div [formGroupName]="j">
                                            <div class="address-form-field control-flex-1">
                                                <label [for]="'legAddressCategory'+i+'-'+j">Address Category</label>
                                                <mat-form-field appearance="outline" class="disabled-field">
                                                    <input [id]="'legAddressCategory'+i+'-'+j" matInput [value]="getAddressCategory(j) | async" readonly />
                                                </mat-form-field>
                                            </div>
                                            <div class="address-form-field control-flex-2">
                                                <label [for]="'legAddress'+i+'-'+j">{{getAddressTitle(j)}}</label>
                                                <mat-form-field appearance="outline" class="disabled-field">
                                                    <input [id]="'legAddress'+i+'-'+j" matInput [value]="getAddress(j)" readonly />
                                                </mat-form-field>
                                            </div>


                                            <div class="form-field">
                                                <label [for]="'shortMiles'+i+'-'+j">Shortest Calculated Miles</label>
                                                <mat-form-field appearance="outline" class="disabled-field">
                                                    <input [id]="'shortMiles'+i+'-'+j" formControlName="shortestMiles" matInput readonly />
                                                </mat-form-field>
                                            </div>
                                            @if(tripType === 'Post') {
                                                <div class="form-field">
                                                    <label [for]="'enteredMiles'+i+'-'+j">Consumer Entered Miles</label>
                                                    <mat-form-field appearance="outline">
                                                        <input [id]="'enteredMiles'+i+'-'+j" formControlName="enteredMiles" matInput [errorStateMatcher]="matcher" (input)="onMilesEntered(i)" integerOnly />
                                                        @if (hasError(`tripAppointments.${i}.tripLegs.${j}.enteredMiles`, 'required')) {
                                                            <mat-error>This field is required.</mat-error>
                                                        }
                                                    </mat-form-field>
                                                </div>
                                                <div class="form-field">
                                                    <label [for]="'approvedMiles'+i+'-'+j">Agency Approved Miles</label>
                                                    <mat-form-field appearance="outline" class="disabled-field">
                                                        <input [id]="'approvedMiles'+i+'-'+j" formControlName="approvedMiles" matInput readonly/>
                                                    </mat-form-field>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                                <div class="leg-container-address-row">
                                    <div class="address-form-field">
                                        <label [for]="'destinationAddressCategory'+i">Address Category</label>
                                        <mat-form-field appearance="outline" class="disabled-field">
                                            <input [id]="'destinationAddressCategory'+i" matInput [value]="getAddressCategory(tripRequestFg.get('isRoundTrip')?.value ? 0: addressFr.length-1) | async" readonly="true" />
                                        </mat-form-field>
                                    </div>
                                    <div class="address-form-field">
                                         <label [for]="'destinationAddress'+i">Destination</label>
                                        <mat-form-field appearance="outline" class="disabled-field">
                                            <input [id]="'destinationAddress'+i" matInput [value]="getAddress(tripRequestFg.get('isRoundTrip')?.value ? 0: addressFr.length-1)" readonly="true" />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            @if (tripType === "Post" && date.get('showExplanationText')?.value) {
                                <div class="explanation-row">
                                    <div class="form-field">
                                        <label [id]="'explanationLabel'+i" [for]="'explanationText'+i">Please enter explanation on why your miles are different <span class="star">*</span></label>
                                        <mat-form-field appearance="outline">
                                            <textarea
                                                [id]="'explanationText'+i"
                                                [attr.aria-labelledby]="'explanationLabel'+i"
                                                matInput
                                                formControlName="explanationText"
                                                name="explanation"
                                                rows="3"
                                                maxlength="1000"
                                                [errorStateMatcher]="matcher"
                                                placeholder="Enter Explanation">
                                            </textarea>
                                            @if (hasError(`tripAppointments.${i}.explanationText`, 'required')) {
                                                <mat-error>This field is required.</mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                </div>
                            }
                        </mat-expansion-panel>
                    </div>
                    <div class="mileage-container">
                        <span class="span-font-weight">Mileage Reimbursement</span>
                        <div class="table-container">
                            <table role="presentation">
                                <caption class="cdk-visually-hidden">Mileage Reimbursement</caption>
                                <thead>
                                    <tr class="table-cell-background" role="row">
                                        <th scope="col"></th>
                                        <th scope="col">Requested</th>
                                        <th scope="col">Approved</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Total Miles</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            <span>{{ date.get('totalMiles')?.value | number: '1.0-0'}}</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ 0 }}</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Mileage Reimbursement Amount</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ date.get('totalMileageAmount')?.value | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ 0.00 | currency }}</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Parking</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ getExpenseAmount(i, 'Parking') | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ 0.00 | currency }}</span>
                                            }
                                        </td>
                                    </tr> 
                                    <tr role="row" >
                                        <td class="table-cell-background" role="cell">
                                            <span>Tolls</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ getExpenseAmount(i, 'Toll') | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ 0.00 | currency}}</span>
                                            }
                                        </td>
                                    </tr> 
                                    <tr role="row">
                                        <td class="table-cell-background" role="cell">
                                            <span>Total Reimbursement</span>
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ getTotalAmount(i) | number: '1.2-2' | currency}}</span>
                                            }
                                        </td>
                                        <td class="bg-gray" role="cell">
                                            @if(tripType === 'Post') {
                                                <span>{{ 0.00 | currency}}</span>
                                            }
                                        </td>
                                    </tr> 
                                </tbody>                                                                 
                            </table>
                        </div>
                    </div>                   
                </div>
            </div>
        }
        @if (appointmentDatesFr.length > 1) {
            <div class="mileage-container">
                <span class="span-font-weight">Mileage Reimbursement</span>
                <div class="table-container">
                    <table role="presentation">
                        <caption class="cdk-visually-hidden">Total Mileage Reimbursement</caption>
                        <thead>
                            <tr class="table-cell-background" role="row">
                                <th scope="col"></th>
                                <th scope="col">Requested</th>
                                <th scope="col">Approved</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr role="row" role="cell">
                                <td class="table-cell-background">
                                    <span>Total Miles</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    <span>{{ getTripTotalMailes() | number: '1.0-0'}}</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ 0 }}</span>
                                    }
                                </td>
                            </tr>
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Mileage Reimbursement Amount</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ getTripTotalMileageAmount() | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ 0.00 | currency }}</span>
                                    }
                                </td>
                            </tr>
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Parking</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ getTripExpenseAmount('Parking') | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ 0.00 | currency }}</span>
                                    }
                                </td>
                            </tr> 
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Tolls</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ getTripExpenseAmount('Toll') | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ 0.00 | currency}}</span>
                                    }
                                </td>
                            </tr> 
                            <tr role="row">
                                <td class="table-cell-background" role="cell">
                                    <span>Total Reimbursement</span>
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ getTripTotalAmount() | number: '1.2-2' | currency}}</span>
                                    }
                                </td>
                                <td class="bg-gray" role="cell">
                                    @if(tripType === 'Post') {
                                        <span>{{ 0.00 | currency}}</span>
                                    }
                                </td>
                            </tr>
                        </tbody>                                                                  
                    </table>
                </div>
            </div> 
        }
        <div class="consent-container">
            <span>The payment amount is pending review and approval by the administrator. It is not final until approved.</span>
            <div class="checkbox-container">
                <mat-checkbox class="options-checkbox-margin" formControlName="tripAuthorize" aria-labelledby="tripAuthorizeLabel"></mat-checkbox>
                <span id="tripAuthorizeLabel">I hereby certify that to the best of my knowledge, the medical trip information listed in this request is true, correct, and complete. I agree to report any changes in circumstances immediately to the MATP Service Provider. I understand that documentation of all eligibility factors may be required to determine eligibility correctly or for auditing purposes and that giving knowingly false statements is a criminal offense. I understand that I have a right to request a Department of Human Services fair hearing if benefits are denied. This affirmation statement covers all attachments required for the determination of eligibility.</span>
            </div>
            @if (hasError(`tripAuthorize`, 'required')) {
                <span class="error-text-format">This field is required</span>
            }
        </div>
    </div>
</div>